module.exports = __webpack_public_path__ + "img/利美康.cb2ecba.png";